<template>
  <div>
    <h1>Add Room</h1>
    <div class="card mt-3">
      <form @submit.prevent='addRoom'>
        <label for="room">Room:</label>
        <input
          type="text"
          id="room"
          name="room"
          autocomplete="off"
          v-model='newRoom.room'
          placeholder="2 characters" maxlength="2" style="text-transform:uppercase"
        />
        <div>
          <input type="submit" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RoomForm',
  data () {
    return {
      newRoom: {
        room: '',
        siteid: this.$route.params.id
      }
    }
  },
  computed: {
    ...mapGetters(['rooms'])
  },
  methods: {
    addRoom () {
      this.newRoom.room = this.newRoom.room.toUpperCase()
      this.$store.dispatch('putRoom', this.newRoom)
      this.newRoom.room = ''
    }
  }
}
</script>
